import {Injectable} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {FieldUiDataObj, FieldValidationObj} from 'mx-core';
import {Observable} from 'rxjs';
import {PrlApplicationPropertiesDataService} from './prl-application-properties.service';


@Injectable({
    providedIn: 'root'
})
export class PrlCaptchaFieldService {

    constructor(private readonly applicationPropertiesService: PrlApplicationPropertiesDataService) {
    }

    public isUsingCaptcha(): Observable<boolean> {
        return this.applicationPropertiesService.isUsingCaptcha();
    }

    public getCaptchaKey(): Observable<string> {
        return this.applicationPropertiesService.getCaptchaKey();
    }


    public injectCaptchaField(fieldsData: FieldUiDataObj[], anchorField: FieldUiDataObj): void {
        const recaptcha = {...anchorField};
        recaptcha.name = 'recaptcha';
        recaptcha.defaultValue = null;

        const validation = new FieldValidationObj();
        validation.required = true;
        recaptcha.validation = validation;
        recaptcha.validation.required = true;
        fieldsData.splice(fieldsData.indexOf(anchorField) + 1, 0, recaptcha);
    }


    public resolve(form: FormGroup, token: string): void {
        form.controls.recaptcha.setValue(token);
    }
}

